export default __webpack_public_path__ + "img/triangle-type.ec462f2.svg";